import React from 'react';
import { Menu, ListItemButton, ListItemText } from '@mui/material';
import { NavLink } from 'react-router-dom';

// Dropdown menu for a "group" nav item. Rendered OUTSIDE <Tabs> (the <Menu>
// portals to <body> anyway) so that <Tabs> only ever contains <Tab> children.
// It stays anchored to its trigger tab via the `anchorEl` passed in.
function NavBarDropdownMenu({ id, anchorEl, onClose, menuItems = [] }: any) {
  return (
    <Menu
      id={id}
      role="list"
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      transitionDuration={100}
      onClose={onClose}
      slotProps={{
        list: { component: 'nav', disablePadding: true },
      }}
    >
      {menuItems.map((item: any) => (
        <ListItemButton
          key={item.id}
          component={NavLink}
          to={item.href}
          target={item.target}
          sx={{ color: (theme: any) => theme.palette.text.primary }}
          onClick={onClose}
        >
          <ListItemText primary={item.label} sx={{ fontWeight: 700 }} />
        </ListItemButton>
      ))}
    </Menu>
  );
}

export default NavBarDropdownMenu;
